module.exports = {
      id: "shorts-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#shorts",
      toString: function () {
        return this.url;
      }
    }